module.exports = __webpack_public_path__ + "img/icon_live_vfull_cancel.0bc6460e.svg";